import { CefGSPAssociation } from '../../ref';
import { GSPCommonElement } from '../GSPCommonElement';
import { IGSPCommonElement } from '../Interface/IGSPCommonElement';

/**
 * 关联关系
 * @author wangjiegj<wangjiegj@inspur.com>
 */


/**
 * 关联关系
 */
export class GSPAssociation extends CefGSPAssociation {

    /**
     * 引用的元素集合
     */
    public RefElementCollection: GSPCommonElement[];
    // private _refElementCollection: IGSPCommonElement[];
    // get RefElementCollection(): IGSPCommonElement[] { if (!this._refElementCollection)
    //  { this._refElementCollection = new Array<IGSPCommonElement>(); } return this._refElementCollection; }
    // set RefElementCollection(value: IGSPCommonElement[]) { this._refElementCollection = value; }

}

